import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./MSAL/authConfig";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { Provider } from 'react-redux'
import store from './store'
import "./style.css";
import { BrowserRouter } from "react-router-dom";

import PublicRoutes from './routes/PublicRoutes'
import PrivateRoutes from './routes/PrivateRoutes'

function App() {
  return (
    <React.StrictMode>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>

          <div className="App">
            <AuthenticatedTemplate>

            <PrivateRoutes/>


            </AuthenticatedTemplate>


            <UnauthenticatedTemplate>

              <PublicRoutes />

            </UnauthenticatedTemplate>
          </div>

        </Provider>
      </MsalProvider>
    </BrowserRouter>
  </React.StrictMode>
  );
}

export default App;
